export default "__VITE_ASSET__BODN2GnQ__"